module.exports = __webpack_public_path__ + "static/img/after_sale_starton.3ea7a460.png";